import { getEntityIconComponent, LABEL_COLORS } from '@/components/neo4j/cytoscape/entity-icons'
import { cn } from '@/utils/cn'

/**
 * The entity type's graph identity — its icon in its canvas colour — so the
 * type picked in a dialog is recognisably the node that lands on the graph.
 */
export function EntityTypeGlyph({ label, className }: { label: string; className?: string }) {
  const Icon = getEntityIconComponent(label)
  const color = LABEL_COLORS[label] ?? LABEL_COLORS.Default
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-lg border border-border bg-muted',
        className
      )}
    >
      <Icon className="size-4" style={{ color: color.fill }} />
    </span>
  )
}
